import { supabase } from '@/lib/supabase';
import type { ClinicReadStore } from '@/lib/medcom/careCommunicationReadSync';

const PAGE = 1000;

interface ReadRow {
  message_key: string;
}

async function list(clinicId: string): Promise<string[] | null> {
  const keys: string[] = [];
  for (let from = 0; from < 20_000; from += PAGE) {
    const { data, error } = await supabase
      .from('care_communication_reads' as never)
      .select('message_key')
      .eq('clinic_id', clinicId)
      .order('message_key')
      .range(from, from + PAGE - 1);
    if (error) {
      console.error('Could not load CareCommunication read state', error.message);
      return null;
    }
    const rows = (data ?? []) as unknown as ReadRow[];
    for (const row of rows) {
      if (typeof row.message_key === 'string' && row.message_key.length > 0) {
        keys.push(row.message_key);
      }
    }
    if (rows.length < PAGE) break;
  }
  return keys;
}

async function save(clinicId: string, messageKey: string): Promise<boolean> {
  const { error } = await supabase.from('care_communication_reads' as never).insert({
    clinic_id: clinicId,
    message_key: messageKey,
  } as never);
  if (!error || error.code === '23505') return true;
  console.error('Could not save CareCommunication read state', error.message);
  return false;
}

export const clinicReadStore: ClinicReadStore = { list, save };
